
/**
 * MD5的加密
 * 
 */
export class Md5Utils {
  /*
   * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
   * Digest Algorithm, as defined in RFC 1321.
   */

  /*
   * Configurable variables. You may need to tweak these to be compatible with
   * the server-side, but the defaults work in most cases.
   */
  static hexcase = 0;  /* hex output format. 0 - lowercase; 1 - uppercase        */
  static b64pad  = ""; /* base-64 pad character. "=" for strict RFC compliance   */
  static chrsz   = 8;  /* bits per input character. 8 - ASCII; 16 - Unicode      */

  /*
   * These are the functions you'll usually want to call
   * They take string arguments and return either hex or base-64 encoded strings
   */
  static hex_md5(s){ return Md5Utils.binl2hex(Md5Utils.core_md5(Md5Utils.str2binl(s), s.length * Md5Utils.chrsz));}
  static b64_md5(s){ return Md5Utils.binl2b64(Md5Utils.core_md5(Md5Utils.str2binl(s), s.length * Md5Utils.chrsz));}
  static str_md5(s){ return Md5Utils.binl2str(Md5Utils.core_md5(Md5Utils.str2binl(s), s.length * Md5Utils.chrsz));}
  static hex_hmac_md5(key, data) { return Md5Utils.binl2hex(Md5Utils.core_hmac_md5(key, data)); }
  static b64_hmac_md5(key, data) { return Md5Utils.binl2b64(Md5Utils.core_hmac_md5(key, data)); }
  static str_hmac_md5(key, data) { return Md5Utils.binl2str(Md5Utils.core_hmac_md5(key, data)); }

  /*
   * Calculate the MD5 of an array of little-endian words, and a bit length
   */
  static core_md5(x, len)
  {


    /* append padding */
    x[len >> 5] |= 0x80 << ((len) % 32);
    x[(((len + 64) >>> 9) << 4) + 14] = len;

    var a =  1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d =  271733878;

    for(var i = 0; i < x.length; i += 16)
    {
      var olda = a;
      var oldb = b;
      var oldc = c;
      var oldd = d;

      a = Md5Utils.md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
      d = Md5Utils.md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
      c = Md5Utils.md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
      b = Md5Utils.md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
      a = Md5Utils.md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
      d = Md5Utils.md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
      c = Md5Utils.md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
      b = Md5Utils.md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
      a = Md5Utils.md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
      d = Md5Utils.md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
      c = Md5Utils.md5_ff(c, d, a, b, x[i+10], 17, -42063);
      b = Md5Utils.md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
      a = Md5Utils.md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
      d = Md5Utils.md5_ff(d, a, b, c, x[i+13], 12, -40341101);
      c = Md5Utils.md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
      b = Md5Utils.md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

      a = Md5Utils.md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
      d = Md5Utils.md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
      c = Md5Utils.md5_gg(c, d, a, b, x[i+11], 14,  643717713);
      b = Md5Utils.md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
      a = Md5Utils.md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
      d = Md5Utils.md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
      c = Md5Utils.md5_gg(c, d, a, b, x[i+15], 14, -660478335);
      b = Md5Utils.md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
      a = Md5Utils.md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
      d = Md5Utils.md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
      c = Md5Utils.md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
      b = Md5Utils.md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
      a = Md5Utils.md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
      d = Md5Utils.md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
      c = Md5Utils.md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
      b = Md5Utils.md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

      a = Md5Utils.md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
      d = Md5Utils.md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
      c = Md5Utils.md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
      b = Md5Utils.md5_hh(b, c, d, a, x[i+14], 23, -35309556);
      a = Md5Utils.md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
      d = Md5Utils.md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
      c = Md5Utils.md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
      b = Md5Utils.md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
      a = Md5Utils.md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
      d = Md5Utils.md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
      c = Md5Utils.md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
      b = Md5Utils.md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
      a = Md5Utils.md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
      d = Md5Utils.md5_hh(d, a, b, c, x[i+12], 11, -421815835);
      c = Md5Utils.md5_hh(c, d, a, b, x[i+15], 16,  530742520);
      b = Md5Utils.md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

      a = Md5Utils.md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
      d = Md5Utils.md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
      c = Md5Utils.md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
      b = Md5Utils.md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
      a = Md5Utils.md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
      d = Md5Utils.md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
      c = Md5Utils.md5_ii(c, d, a, b, x[i+10], 15, -1051523);
      b = Md5Utils.md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
      a = Md5Utils.md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
      d = Md5Utils.md5_ii(d, a, b, c, x[i+15], 10, -30611744);
      c = Md5Utils.md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
      b = Md5Utils.md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
      a = Md5Utils.md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
      d = Md5Utils.md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
      c = Md5Utils.md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
      b = Md5Utils.md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

      a = Md5Utils.safe_add(a, olda);
      b = Md5Utils.safe_add(b, oldb);
      c = Md5Utils.safe_add(c, oldc);
      d = Md5Utils.safe_add(d, oldd);
    }
    return Array(a, b, c, d);

  }

  /*
   * These functions implement the four basic operations the algorithm uses.
   */
  static md5_cmn(q, a, b, x, s, t)
  {
    return Md5Utils.safe_add(Md5Utils.bit_rol(Md5Utils.safe_add(Md5Utils.safe_add(a, q), Md5Utils.safe_add(x, t)), s),b);
  }
  static md5_ff(a, b, c, d, x, s, t)
  {
    return Md5Utils.md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
  }
  static md5_gg(a, b, c, d, x, s, t)
  {
    return Md5Utils.md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
  }
  static md5_hh(a, b, c, d, x, s, t)
  {
    return Md5Utils.md5_cmn(b ^ c ^ d, a, b, x, s, t);
  }
  static md5_ii(a, b, c, d, x, s, t)
  {
    return Md5Utils.md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
  }

  /*
   * Calculate the HMAC-MD5, of a key and some data
   */
  static core_hmac_md5(key, data)
  {
    var bkey = Md5Utils.str2binl(key);
    if(bkey.length > 16) bkey = Md5Utils.core_md5(bkey, key.length * Md5Utils.chrsz);

    var ipad = Array(16), opad = Array(16);
    for(var i = 0; i < 16; i++)
    {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }

    var hash = Md5Utils.core_md5(ipad.concat(Md5Utils.str2binl(data)), 512 + data.length * Md5Utils.chrsz);
    return Md5Utils.core_md5(opad.concat(hash), 512 + 128);
  }

  /*
   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
   * to work around bugs in some JS interpreters.
   */
  static safe_add(x, y)
  {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xFFFF);
  }

  /*
   * Bitwise rotate a 32-bit number to the left.
   */
  static bit_rol(num, cnt)
  {
    return (num << cnt) | (num >>> (32 - cnt));
  }

  /*
   * Convert a string to an array of little-endian words
   * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
   */
  static str2binl(str)
  {
    var bin = Array();
    var mask = (1 << Md5Utils.chrsz) - 1;
    for(var i = 0; i < str.length * Md5Utils.chrsz; i += Md5Utils.chrsz)
      bin[i>>5] |= (str.charCodeAt(i / Md5Utils.chrsz) & mask) << (i%32);
    return bin;
  }

  /*
   * Convert an array of little-endian words to a string
   */
  static binl2str(bin)
  {
    var str = "";
    var mask = (1 << Md5Utils.chrsz) - 1;
    for(var i = 0; i < bin.length * 32; i += Md5Utils.chrsz)
      str += String.fromCharCode((bin[i>>5] >>> (i % 32)) & mask);
    return str;
  }

  /*
   * Convert an array of little-endian words to a hex string.
   */
  static binl2hex(binarray)
  {
    var hex_tab = Md5Utils.hexcase ? "0123456789AssemblyDEF" : "0123456789assemblydef";
    var str = "";
    for(var i = 0; i < binarray.length * 4; i++)
    {
      str += hex_tab.charAt((binarray[i>>2] >> ((i%4)*8+4)) & 0xF) +
             hex_tab.charAt((binarray[i>>2] >> ((i%4)*8  )) & 0xF);
    }
    return str;
  }

  /*
   * Convert an array of little-endian words to a base-64 string
   */
  static binl2b64(binarray)
  {
    var tab = "AssemblyDEFGHIJKLMNOPQRSTUVWXYZassemblydefghijklmnopqrstuvwxyz0123456789+/";
    var str = "";
    for(var i = 0; i < binarray.length * 4; i += 3)
    {
      var triplet = (((binarray[i   >> 2] >> 8 * ( i   %4)) & 0xFF) << 16)
                  | (((binarray[i+1 >> 2] >> 8 * ((i+1)%4)) & 0xFF) << 8 )
                  |  ((binarray[i+2 >> 2] >> 8 * ((i+2)%4)) & 0xFF);
      for(var j = 0; j < 4; j++)
      {
        if(i * 8 + j * 6 > binarray.length * 32) str += Md5Utils.b64pad;
        else str += tab.charAt((triplet >> 6*(3-j)) & 0x3F);
      }
    }
    return str;
  }

  static utf16to8(str) {
      var out, i, len, c;

      out = "";
      len = str.length;
      for (i = 0; i < len; i++) {
          c = str.charCodeAt(i);
          if ((c >= 0x0001) && (c <= 0x007F)) {
              out += str.charAt(i);
          } else if (c > 0x07FF) {
              out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
              out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
              out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
          } else {
              out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
              out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
          }
      }
      return out;
  }

  static utf8to16(str) {
      var out, i, len, c;
      var char2, char3;

      out = "";
      len = str.length;
      i = 0;
      while (i < len) {
          c = str.charCodeAt(i++);
          switch (c >> 4) {
              case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
                  // 0xxxxxxx
                  out += str.charAt(i - 1);
                  break;
              case 12: case 13:
                  // 110x xxxx 10xx xxxx
                  char2 = str.charCodeAt(i++);
                  out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                  break;
              case 14:
                  // 1110 xxxx 10xx xxxx 10xx xxxx
                  char2 = str.charCodeAt(i++);
                  char3 = str.charCodeAt(i++);
                  out += String.fromCharCode(((c & 0x0F) << 12) |
                         ((char2 & 0x3F) << 6) |
                         ((char3 & 0x3F) << 0));
                  break;
          }
      }

      return out;
  }

}
